module.exports = __webpack_public_path__ + "static/img/no-file.0ab0aa30.png";